import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

class Design4 extends Component {
  render() {
    return (
      <section className="landing-section landing-split" id="marketer">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <span className="landing-eyebrow">Optimisation</span>
              <h2>Moins de tâches manuelles, plus de temps pour l’éducation.</h2>
              <p className="landing-lead">
                La plateforme rassemble les opérations administratives, scolaires et financières pour réduire les
                doublons, limiter les erreurs et améliorer la qualité du suivi.
              </p>

              <div className="landing-metric-row">
                <div>
                  <FeatherIcon icon="clock" size={22} />
                  <strong>Gain de temps</strong>
                  <span>Processus plus rapides</span>
                </div>
                <div>
                  <FeatherIcon icon="database" size={22} />
                  <strong>Données claires</strong>
                  <span>Informations centralisées</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="landing-image-frame">
                <img className="img-fluid" src="assets/img/marketer/marketer.png" alt="Optimisation scolaire" />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Design4;
